var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("form-login", {
        attrs: {
          fetching: _vm.fetching,
          message: _vm.message,
          "message-type": _vm.messageType,
        },
        on: { submit: _vm.submit },
      }),
      _c("div", { staticClass: "content copyright is-centered" }, [
        _c(
          "p",
          [
            _c("router-link", { attrs: { to: _vm.forgottenpassword } }, [
              _vm._v("Forgot password?"),
            ]),
          ],
          1
        ),
        _vm._m(1),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false",
              },
            ],
          },
          [
            _vm._v(" Looking for ways to grow your business "),
            _c("a", { attrs: { href: "#" } }, [_vm._v("learn more")]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("h1", { staticClass: "title is-bold" }, [_vm._v("Log in")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(" © DailyCare Pty Ltd · "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.dailycare.com.au/terms-of-use/",
            target: "_blank",
            rel: "noreferrer",
          },
        },
        [_vm._v("Terms of use")]
      ),
      _vm._v(" · "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.dailycare.com.au/privacy-policy/",
            target: "_blank",
            rel: "noreferrer",
          },
        },
        [_vm._v("Privacy policy")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }